import {
  CHECK_DEPOSIT_STATUS,
  PROCESSING_STATUSES,
  NEEDS_REVIEW_STATUSES
} from '#client/constants/transaction';

export const getStatusPayload = (status) => {
  switch (status) {
    case '':
    case 'all':
      return undefined;
    case CHECK_DEPOSIT_STATUS.PROCESSING:
      return PROCESSING_STATUSES;
    case CHECK_DEPOSIT_STATUS.NEEDS_REVIEW:
      return NEEDS_REVIEW_STATUSES;
    default:
      return status;
  }
};
